import React from "react"

// Dashboard
import Dashboard from "../pages/Dashboard/index"

// import CustomFilterDemo from "pages/Tables/CustomFilterDemo";
import JobsAllactiveemp from "components/Jobs/JobsAllactiveemp"

import Jobsdetails from "ATSComponents/JobsAts/Jobsdetails"
//candidates
import AllActiveemp from "ATSComponents/Candidates/AllActiveemp"
import CandidateEditFrom from "components/Candidates/CandidateEditForm"
import CandidateEditFormExtra from "ATSComponents/Candidates/CandidateEditFormExtra"
import AdminDashboard from "ATSComponents/Common/AdminDashboard"

//contacts
import ContactsAllActive from "ATSComponents/Contacts/ContactsAllActive"

import ContactEditForm from "ATSComponents/Contacts/ContactsEditForm"

// importBulk

import ImportBulkResume from "ATSComponents/Common/ImportResume"

//companies
import CompaniesAllActive from "ATSComponents/Companies/CompaniesAllActive"
// import CompaniesMyActive from "ATSComponents/Companies/CompaniesMyActive";
// import CompaniesArchived from "ATSComponents/Companies/CompaniesArchived";
// import CompaniesTaskList from "ATSComponents/Companies/CompaniesTaskList";
// import CompaniesActivity from "ATSComponents/Companies/CompaniesActivity";
// import CompaniesDuplicateList from "ATSComponents/Companies/CompaniesDuplicateList";
import CompanyEditForm from "ATSComponents/Companies/CompanyEditForm"

// jobs
import JobAllActive from "ATSComponents/JobsAts/JobAllActive"
import AllActiveCompanies from "ATSComponents/Companies/CompaniesAllActive"
import UploadResumeForm from "ATSComponents/Candidates/UploadResumeForm"
import JobsEditForm from "ATSComponents/JobsAts/JobsEditForm"
import CandidatePostFormExtra from "ATSComponents/Candidates/CandidatePostFormExtra"
import JobsPostForm from "ATSComponents/JobsAts/JobsPostForm"

//reports
import ActiveJobSummary from "ATSComponents/Reports/ActiveJobSummary"
import RecruiterPerformanceReport from "ATSComponents/Reports/RecruiterPerformanceReport"
import MyPlacementReport from "ATSComponents/Reports/MyPlacementReport"
import LoginPage from "ATSComponents/login"
import RegistrationPage from "ATSComponents/Registration"
import SourcePerformanceReport from "ATSComponents/Reports/SourcePerformanceReport"
import CallReport from "ATSComponents/Reports/CallReport"
import TimeToHire from "ATSComponents/Reports/TimeToHire"
import MyPipelineReport from "ATSComponents/Reports/MyPipelineReports"
import PlacementReport from "ATSComponents/Reports/PlacementReport"

// calender
import CalenderActive from "ATSComponents/Calendar/CalenderActive"
import CalenderAll from "ATSComponents/Calendar/CalenderAll"

// dashboard

import RecruiterDashboard from "ATSComponents/Dashboard/RecruiterDashboard"
import ManagerDashboard from "ATSComponents/Dashboard/ManagerDashboard"

// candidate pipeline
import TableView from "ATSComponents/CandidatePipeline/TableView"
import KanbanView from "ATSComponents/CandidatePipeline/KanbanView"

//  emials

import OutBox from "ATSComponents/Emails/OutBox"
import SentEmails from "ATSComponents/Emails/SentEmails"

import AdminDashboardats from "ATSComponents/Common/AdminDasboardats"

//login
// import LoginPage from "ATSComponents/login";

// Advanced Search
import SearchResults from "utils/SearchResults"

import Lookup_Cus from "ATSComponents/Admin_Module/Lookup_Cus"
import MyAccount from "ATSComponents/Admin_Module/MyAccount"
import Usermanagment from "ATSComponents/Admin_Module/Usermanagment"
import Settings from "ATSComponents/Admin_Module/Settings"

import ImportFromCSV from "ATSComponents/Candidates/ImportfromcsvCandidates"
import ImportFromCSVCompanies from "ATSComponents/Companies/ImportfromcsvCompanies"
import ImportFromCSVContacts from "ATSComponents/Contacts/ImportfromcsvContacts"
import ImportFromCSVJobs from "ATSComponents/JobsAts/ImportfromcsvJobs"
import JobOrdersView from "ATSComponents/JobOrder/JobOrdersView"
import MyJobOrdersView from "ATSComponents/JobOrder/myJobOrdersView"
import CreateJobOrder from "ATSComponents/JobOrder/CreateJobOrder"
import CandidateDetailsView from "ATSComponents/JobOrder/CandidateDetailsView"
import DepartmentView from "ATSComponents/Department/DepartmentView"
import DesignationView from "ATSComponents/Department/DesignationView"
import AtsCandidatesAll from "ATSComponents/Candidates/AtsCandidatesAll"
import AtsArchiveeCandidates from "ATSComponents/Candidates/AtsArchiveeCandidates"
import SelectedCandidates from "ATSComponents/Candidates/SelectedCandidates"
import UnselectedCandidates from "ATSComponents/Candidates/UnselectedCandidates"
import OptOutCandidates from "ATSComponents/Candidates/OptOutCandidates"

import OrganizationList from "ATSComponents/Organization/OrganizationList"
import CandidateStepperForm from "ATSComponents/Candidates/AddCandidate"
import JobTimeLineView from "ATSComponents/JobOrder/JobTimeLineView"
import CandidateTimeLineView from "ATSComponents/Candidates/CandidateTimeLineView"
import CalenderArchive from "ATSComponents/Calendar/CalenderArchive"
import TodaySchedule from "ATSComponents/Calendar/TodaySchedule"
import ArchivedJobOrders from "ATSComponents/JobOrder/ArchivedJobOrders"
import MyCalendar from "ATSComponents/Calendar/MyCalendar"
import LoginActivityLogs from "ATSComponents/Reports/LoginActivityLogs"
import AllReferralCandidates from "ATSComponents/Candidates/AllReferralCandidates"

import {
  generateToken,
  getDeviceTokenView,
  messaging,
} from "components/Common/FirebaseConfig"
import { onMessage } from "firebase/messaging"
import ExtensionLogs from "ATSComponents/Reports/ExtensionLogs"
import SocialMedia from "ATSComponents/Common/SocialMedia"
import NotFound from "components/NotFound"
import RecruitersReports from "ATSComponents/Reports/RecruitersReports"
import AgentList from "ATSComponents/AgentList"
import AgentCreation from "ATSComponents/AgentCreation"
import TelephonicTests from "ATSComponents/Reports/TelephonicTests"
import JobOrderRecruiterReport from "ATSComponents/JobOrder/JobOrderRecruiterReport"
import TsCandidateScreenLogs from "ATSComponents/JobOrder/TsCandidateScreen"
import TalentScanParsingLogsPage from "ATSComponents/JobOrder/TalentScanLogs"
import JobOrderReportDetail from "ATSComponents/JobOrder/joborderreportdetails"
import ApiLogs from "ATSComponents/Reports/APiLogs"

// import SocialMediaPost from "ATSComponents/JobOrder/SocialMediaPost"
// import SocialMediaPost2 from "ATSComponents/JobOrder/SocialMediaPost2"
const userRoutes = [
  // Jobs
  { path: "/allactive-jobs", component: <JobAllActive /> },

  // Candidates

  { path: "/candidate-edit", component: <CandidateEditFrom /> },
  { path: "/candidate-editform", component: <CandidateEditFormExtra /> },
  { path: "/candidate-postform", component: <CandidatePostFormExtra /> },
  { path: "/uploadresumeform", component: <UploadResumeForm /> },
  // { path: "/admin-dashboard", component: <AdminDashboard /> },

  {
    path: "/allactive-candidates",
    component: <AllActiveemp key="all_active_employees" />,
  },
  {
    path: "/candidates-added",
    component: <AllActiveemp key="added_by_me" type="added_by_me" />,
  },
  {
    path: "/candidates-opened",
    component: <AllActiveemp key="opened_by_me" type="opened_by_me" />,
  },
  {
    path: "/candidates-duplicate",
    component: (
      <AllActiveemp key="duplicate-candidates" type="duplicate-candidates" />
    ),
  },
  {
    path: "/myactive-candidates",
    component: (
      <AllActiveemp key="my-active-candidates" type="my-active-candidates" />
    ),
  },
  {
    path: "/candidates-activity",
    component: <AllActiveemp key="activity_log" type="activity_log" />,
  },
  {
    path: "/candidates-archived",
    component: <AllActiveemp key="archived_only" param="archived_only=true" />,
  },
  { path: "/candidate-editform/:id", component: <CandidateEditFormExtra /> },
  {
    path: "/candidates-tasklist",
    component: <AllActiveemp key="task-list" type="task-list" />,
  },
  //Advance Search
  { path: "/search-results", component: <SearchResults /> },

  // contacts

  {
    path: "/all-employees",
    component: <ContactsAllActive key="contacts-allactive" />,
  },

  {
    path: "/contacts-tasklist",
    component: <ContactsAllActive key="task-list" type="task-list" />,
  },
  {
    path: "/contacts-activity",
    component: <ContactsAllActive key="activity-log" type="activity-log" />,
  },

  { path: "/contacts-editform/", component: <ContactEditForm /> },

  {
    path: "/contacts-myactive",
    component: <ContactsAllActive key="my-active" type="my-active" />,
  },
  {
    path: "/contacts-archived",
    component: (
      <ContactsAllActive key="archived_only" param="archived_only=true" />
    ),
  },
  {
    path: "/contacts-duplicate",
    component: (
      <ContactsAllActive key="duplicate-contacts" type="duplicate-contacts" />
    ),
  },

  { path: "/lookup_Cus", component: <Lookup_Cus /> },
  { path: "/myAccount", component: <MyAccount /> },
  { path: "/usermanagment", component: <Usermanagment /> },
  { path: "/settings", component: <Settings /> },
  { path: "/socialMedia", component: <SocialMedia /> },
  { path: "/tsLogs", component: <TalentScanParsingLogsPage /> },
  { path: "/tsScreen", component: <TsCandidateScreenLogs /> },
  // { path: "/socialMediaPost", component: <SocialMediaPost /> },
  // { path: "/socialMediaPost2", component: <SocialMediaPost2 /> },
  

  // companies

  // { path: "/organization-companies", component: <CompaniesAllActive key="companies-allactive" /> },
  {
    path: "/companies-myactive",
    component: <CompaniesAllActive key="my-active" type="my-active" />,
  },
  {
    path: "/companies-archived",
    component: (
      <CompaniesAllActive key="archived_only" param="archived_only=true" />
    ),
  },
  {
    path: "/companies-tasklist",
    component: <CompaniesAllActive key="task-list" type="task-list" />,
  },
  {
    path: "/companies-activity",
    component: <CompaniesAllActive key="activity_log" type="activity_log" />,
  },
  {
    path: "/companies-duplicatelist",
    component: (
      <CompaniesAllActive
        key="duplicate-companies"
        type="duplicate-companies"
      />
    ),
  },
  { path: "/companies-editform", component: <CompanyEditForm /> },

  //jobs
  { path: "/all-job-orders", component: <JobOrdersView /> },
  { path: "/my-job-orders", component: <MyJobOrdersView /> },
  { path: "/create-job-orders-view", component: <CreateJobOrder /> },
  { path: "/aiReport", component: <JobOrderReportDetail /> },
  { path: "/create-job-orders-view/:id", component: <CreateJobOrder /> },
  { path: "/candidate-details-view", component: <CandidateDetailsView /> },
  { path: "/add-candidate", component: <CandidateStepperForm /> },
  { path: "/agentList", component: <AgentList /> },
  { path: "/agentcreation", component: <AgentCreation /> },
  { path: "/extension-logs", component: <ExtensionLogs/> },
  { path: "/telephonic-tests", component: <TelephonicTests /> },
  { path: "/job-order-recruiter-report", component: <JobOrderRecruiterReport /> },

  { path: "/job-time-line", component: <JobTimeLineView /> },
  { path: "/candidate-time-line", component: <CandidateTimeLineView /> },

  { path: "/organization-department", component: <DepartmentView /> },
  { path: "/organization-designation", component: <DesignationView /> },

  { path: "/organization-companies", component: <OrganizationList /> },

  { path: "/all_candidates", component: <AtsCandidatesAll /> },
  // { path: "/archive_candidates", component: <AtsArchiveeCandidates /> },
  { path: "/selected_candidates", component: <SelectedCandidates /> },
  { path: "/rejected_candidates", component: <UnselectedCandidates /> },
  { path: "/opt-out-candidates", component: <OptOutCandidates /> },
  { path: "/all_referral_candidates", component: <AllReferralCandidates /> },

  ,
  { path: "/allactive-jobs", component: <JobAllActive /> },
  {
    path: "/addedbyme-jobs",
    component: <JobAllActive key="added_by_me" type="added_by_me" />,
  },
  // { path: "/archived-job-orders", component: <JobAllActive key="archived_only=true" param="archived_only=true" /> },
  { path: "/archived-job-orders", component: <ArchivedJobOrders /> },
  {
    path: "/joballclosed-jobs",
    component: <JobAllActive key="closed-jobs" type="closed-jobs" />,
  },
  {
    path: "/myactive-jobs",
    component: <JobAllActive key="my-active" type="my-active" />,
  },
  {
    path: "/jobactivitylog-jobs",
    component: <JobAllActive key="activity-log" type="activity-log" />,
  },
  {
    path: "/assignedtome-jobs",
    component: <JobAllActive key="assigned-to-me" type="assigned-to-me" />,
  },
  { path: "/jobs-editform", component: <JobsEditForm /> },
  { path: "/jobs-editform/:id", component: <JobsEditForm /> },

  { path: "/jobs-postform", component: <JobsPostForm /> },

  { path: "/job-details", component: <Jobsdetails /> },
  //Admin Module
  { path: "/admin-dashboard", component: <AdminDashboardats /> },

  //reports
  { path: "/activejob-summary", component: <ActiveJobSummary /> },
  { path: "/login-activity-report", component: <LoginActivityLogs /> },
  {
    path: "/recruiter-performance-report",
    component: <RecruiterPerformanceReport />,
  },
  { path: "/my-placement-report", component: <MyPlacementReport /> },
  { path: "/time-to-hire", component: <TimeToHire /> },
  {
    path: "/source-performance-report",
    component: <SourcePerformanceReport />,
  },
  { path: "/call-report", component: <CallReport /> },
  { path: "/pipeline-report", component: <MyPipelineReport /> },
  { path: "/tracker-report", component: <RecruitersReports /> },
  // Calender
  // { path: "/todays-scheduled", component: <CalenderActive /> },
  { path: "/todays-scheduled", component: <TodaySchedule /> },

  { path: "/all-calendar", component: <CalenderAll /> },
  { path: "/archive-calendar", component: <CalenderArchive /> },
  { path: "/placement-report", component: <PlacementReport /> },
  { path: "/my-calendar", component: <MyCalendar /> },

  // Tables
  { path: "/import-bulkresume", component: <ImportBulkResume /> },

  // dashboard

  { path: "/recruiter-dashboard", component: <RecruiterDashboard /> },
  { path: "/ats-dashboard", component: <ManagerDashboard /> },

  // candidate pipeline
  { path: "/tableview", component: <TableView /> },
  { path: "/candidate-pipeline", component: <KanbanView /> },

  // Emails
  { path: "/outbox", component: <OutBox /> },
  { path: "/sentemails", component: <SentEmails /> },
  { path: "/logs", component: <ApiLogs /> },

  // import from csv
  { path: "/importfromcsv-candidates", component: <ImportFromCSV /> },
  { path: "/importfromcsv-companies", component: <ImportFromCSVCompanies /> },
  { path: "/importfromcsv-contacts", component: <ImportFromCSVContacts /> },
  { path: "/importfromcsv-jobs", component: <ImportFromCSVJobs /> },
  {
    path: "*",
    component: <NotFound />,
  }


  //Login
  // { path: "/login", component: <LoginPage /> },

  // this route should be at the end of all other routes
  // { path: "/", component: <Dashboard /> },
]

export { userRoutes }
